import { gql } from '@apollo/client';

export const GET_PROJECT_NAMES = gql`
  query GetProjectNames {
    getProjects {
      projectName
      id
    }
  }
`;

export const GET_MEMBERS = gql`
  query GetMembers($displayName: String!) {
    getMembers(filter: { displayName: $displayName }) {
      count
      data {
        displayName
        id
      }
    }
  }
`;

export const GET_MEMBERSS = gql`
  query GetMembers($ids: [String]) {
    getMembers(filter: { ids: $ids }) {
      data {
        providerId
        displayName
        id
      }
    }
  }
`;

export const SUBSCRIPTION = gql`
  subscription MySubscription($actionUserId: ID!) {
    realTimeUpdate(memberId: $actionUserId) {
      memberId
      description
      createdAt
    }
  }
`;

export const GET_NOTIFICATIONS = gql`
  query MyQuery(
    $memberId: ID!
    $isFlagged: Boolean
    $projectId: ID
    $resourceId: ID
    $deliveryResponsibleId: ID
    $skip: Int
  ) {
    getNotifications(
      filter: {
        memberId: $memberId
        isFlagged: $isFlagged
        projectId: $projectId
        resourceId: $resourceId
        deliveryResponsibleId: $deliveryResponsibleId
      }
      pagination: { skip: $skip, take: 10 }
    ) {
      approvalRequest {
        description
        id
        metadata
        state
        type
      }
      approvalRequestId
      createdAt
      deliveredAt
      description
      id
      isFlagged
      memberId
      actionUserId
      projectChange {
        description
        id
        initiatedMemberId
        metadata
        projectId
      }
      type
    }
  }
`;

export const MARK_AS_READ = gql`
  mutation MyMutation($id: ID!, $deliveredAt: AWSDateTime!) {
    editNotification(input: { id: $id, deliveredAt: $deliveredAt })
  }
`;

export const TOGGLE_FLAG = gql`
  mutation ToggleFlag($id: ID!, $isFlagged: Boolean!) {
    editNotification(input: { id: $id, isFlagged: $isFlagged })
  }
`;
